module.exports = __webpack_public_path__ + "static/media/intro-safetydrl.d617bb45.jpg";